import React from 'react';

interface InlineLinkProps {
  text: string;
  href?: string;
  onClick?: (e: React.FormEvent) => void;
}

class InlineLink extends React.Component<InlineLinkProps> {
  render() {
    const { text, href = '#', onClick = () => {} } = this.props;

    return (
      <a
        onClick={onClick}
        href={href}
        rel="noopener noreferrer"
        target="_blank"
      >
        {text}
      </a>
    );
  }
}

export default InlineLink;



// WEBPACK FOOTER //
// ./app/common/components/billable-guests-alert/inline-link.tsx